import MenuLayout from '@/screens/menu'
import Menu from '@/screens/menu/List'
import DishesList from '@/screens/dishes/List'

import auth from './middleware/auth'

import store from '@/store'

const routes = [
  {
    path: '/menu',
    name: 'MenuLayout',
    component: {
      ...MenuLayout,
      beforeRouteUpdate (to, from, next) {
        if (to.name === 'MenuLayout') {
          const routes = {
            manager: 'Menu',
            chef: 'Menu',
            buyer: 'Dishes'
          }
          const role = store.state.login.role
          return next({ name: routes[role] })
        }
        return next()
      },
      beforeRouteEnter (to, from, next) {
        if (to.name === 'MenuLayout') {
          const routes = {
            manager: 'Menu',
            chef: 'Menu',
            buyer: 'Dishes'
          }
          const role = store.state.login.role
          return next({ name: routes[role] })
        }
        return next()
      }
    },
    meta: { requireAuth: true },
    children: [
      {
        path: 'sheet',
        name: 'Menu',
        component: Menu,
        meta: {
          requireAuth: true,
          permissions: ['manager', 'chef'],
          middleware: { auth }
        }
      },
      {
        path: 'dishes',
        name: 'Dishes',
        component: DishesList,
        meta: {
          requireAuth: true,
          permissions: ['manager', 'buyer'],
          middleware: { auth }
        }
      }
    ]
  }
]

export default routes
